import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../state/store";
import ProductCard from "../ProductCard";
import NoData from "../NoData";

// Props for Redux-based filtering
interface StateProductListProps {
  categoryIds: string[];
  minPrice: number;
  maxPrice: number;
  inStock: boolean;
  limit: number;
  offset: number;
  searchQuery: string;
}

const StateProductList: React.FC<StateProductListProps> = ({
  categoryIds,
  minPrice,
  maxPrice,
  inStock,
  limit,
  offset,
  searchQuery
}) => {
  const allProducts = useSelector((state: RootState) => state.product.items);

//   console.log("All Products from Redux:", allProducts);

  const filtered = allProducts
    .filter(prod =>
      categoryIds.includes(prod.categoryId) &&
      prod.price >= minPrice &&
      prod.price <= maxPrice &&
      (inStock ? prod.stockQuantity : true) &&
      prod.name.toLowerCase().includes(searchQuery.toLowerCase())
    )
    .slice(offset, offset + limit);

  return (
    <div className="category_grid">
      {filtered.length > 0 ? (
        filtered.map(product => (
          <ProductCard key={product.id} product={product} />
        ))
      ) : (
        <NoData message="No products found in this category." />
      )}
    </div>
  );
};

export default StateProductList;
